import { Component, OnInit } from '@angular/core';
import { fuseAnimations } from '@fuse/animations';
import { Router } from '@angular/router';
import *  as $ from 'jquery';
import { ResultadosService } from '../resultados.service';
import { WizardService } from 'app/main/wizard-cgo/services/wizard.service';
import * as backInter from 'app/auth/auth-data.model';
import Swal from 'sweetalert2';

///IDIOMAS
import { lang_resultados } from 'app/idiomas/i18n/resultados/resultados.lang';
import { lang_wizard } from 'app/idiomas/i18n/wizard/wizard.lang';
import { lang_izzi } from 'app/idiomas/i18n/Izzi/izzi.lang';
import { lang_modales } from 'app/idiomas/i18n/modales/modales.lang';
import { lang_resultados_izzi } from 'app/idiomas/i18n/Izzi/resultados/resultados.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import {TranslateLoader, TranslateModule, TranslateService} from "@ngx-translate/core";
@Component({
  selector: 'results5',
  templateUrl: './results5.component.html',
  styleUrls: ['./results5.component.scss'],
  animations : fuseAnimations
})
export class Results5Component implements OnInit {

  nivelUsuario: number;
  nombreUsuario: string;
  empresasCGO2: backInter.getCorreosResuCGO2;
  empresaDeCGO2 = false;
  productosAsignados: any[]  =[];
  productosAsignados_tmp: any[]  =[];
  productosLegacy: any[]  =[];
  tipoSeleccionado: string;
  ForAllViejas:boolean=true;
  cargando = true;
  certificarSi=false;
  idInstituto:any;
  validarIzzi:boolean=false;

  funciones: any[]= [
    {
      id      : 'CERTIFICAR',
      slug    : 'certificar',
      category: 'CGO',
      icon : 'bubble_chart',
      imagen: 'res-cert',
      tipo: '1'
    },
    {
      id      : 'MEDIR',
      slug    : 'medir',
      category: 'CGO',
      icon : 'bubble_chart',
      imagen: 'res-med',
      tipo: '2'
    },
    {
      id      : 'PULSE',
      slug    : 'pulse-check',
      category: 'CGO',
      icon : 'bubble_chart',
      imagen: 'res-pc',
      tipo: '3'
    }
  ];

  sinCertificar: boolean; //si no hay productos certificar, se usa este boolean para pintar los productos resultados
  conCyR: boolean; //si no hay productos certificar, se usa este boolean para pintar los productos resultados

  constructor(
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private wizardService: WizardService,
    private router: Router,
    private servTableau: ResultadosService,
    private translateSrv: TranslateService,
  )
  {
    lang_wizard.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });

    if(localStorage.getItem('tipoIzzi')){
      lang_resultados_izzi.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
      });
      this.funciones= [
        {
          id      : 'CERTIFICAR',
          slug    : 'certificar',
          category: 'CGO',
          icon : 'bubble_chart',
          imagen: 'res-cert',
          tipo: '1'
        }
      ];
      lang_izzi.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
      });
      this.validarIzzi=true;
    }
    else{
      lang_resultados.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
      });

      this.funciones= [
        {
          id      : '31',
          slug    : 'certificar',
          category: 'CGO',
          icon : 'bubble_chart',
          imagen: 'res-cert',
          tipo: '1'
        },
        {
          id      : '32',
          slug    : 'medir',
          category: 'CGO',
          icon : 'bubble_chart',
          imagen: 'res-med',
          tipo: '2'
        },
        {
          id      : '33',
          slug    : 'pulse-check',
          category: 'CGO',
          icon : 'bubble_chart',
          imagen: 'res-pc',
          tipo: '3'
        }
      ];
      this.validarIzzi=false;
    }
  }


  ngOnInit() {
    this.nivelUsuario = this.servTableau.getNivel();
    this.nombreUsuario = this.wizardService.getNombreUsuario();
    this.getEmpresasCGO2();
    this.idInstituto=localStorage.getItem('instituto');
    console.log(localStorage.getItem('instituto'));
  }

  getEmpresasCGO2(){
    this.servTableau.getCGO2EmpresasResults().subscribe((respuesta:backInter.getCorreosResuCGO2) => {
      this.empresasCGO2 = respuesta;
      if(this.empresasCGO2.correos.indexOf(this.nombreUsuario) != -1){
        this.empresaDeCGO2 = true;
      }
    })
  }

  Tableau(){
    let revisar = this.servTableau.getNivel();
    console.log(revisar);
    switch(revisar){
      case 2: case 3: $('#RecDatos2').submit();
      break;

      case 4: case 5: $('#RecDatos').submit();
      break;
    }
  }

  goBack(){
    this.tipoSeleccionado = null;
    this.productosAsignados = [];
    this.productosAsignados_tmp = [];
    this.cargando = true;
    this.ForAllViejas=true;
  }
  tituloResultado:any;
  obtieneProductos(tipoProducto:string){
    this.tipoSeleccionado = tipoProducto;
    console.log("Tipo de producto");
    console.log(this.tipoSeleccionado);
    switch(this.tipoSeleccionado){
      case "1":
      let tituloResult1 = 'RESULTADOS.TABPRIN5.TABPRO';
      //this.translateSrv.get(tituloResult1).subscribe((res: string) => { tituloResult1 = res; });
      this.tituloResultado=tituloResult1;
      break;
      case "2":
      let tituloResult2 = 'RESULTADOS.TABPRIN.TABCER';
      //this.translateSrv.get(tituloResult2).subscribe((res: string) => { tituloResult2 = res; });
      this.tituloResultado=tituloResult2;
      break;
      case "3":
      let tituloResult3 = 'RESULTADOS.TABPRIN.TABPULSE';
      //this.translateSrv.get(tituloResult3).subscribe((res: string) => { tituloResult3 = res; });
      this.tituloResultado=tituloResult3;
      break;
    }
    console.log("Titulo "+this.tituloResultado);

    switch(this.servTableau.getNivel()){
      case 2: case 3:
      this.navigateTo('/results/trust_index/certificar','admin',null);
      break;
      case 1: case 5:
      this.wizardService.getProductos().subscribe( (respuesta: backInter.infoProductos) => {
        console.log(respuesta);

        let prods: any;
        let prodsRC:any;
        let prodsResults:any;
        let url: string;
        let nombre: string;
        prodsResults=respuesta.productosResultados5cero;
        switch(tipoProducto){
          case '1':
          if(respuesta.productosCertificar.length > 0 && respuesta.productosResultados.length > 0){
            prods = respuesta.productosCertificar;
            prodsRC = respuesta.productosResultados;
            console.log(prods);
            console.log(prodsRC);
            prodsRC.forEach((element,i) => {
              prods.forEach((eleme,i) => {
                console.log(eleme.fecha);
                console.log(element.fechaCertificar);
                if(eleme.fechaCertificar==element.fecha){
                  // prods.splice(i,1);
                }
              });

            });
            this.conCyR=true;
            console.log(prods);
          }

          else if(respuesta.productosCertificar.length > 0){
            prods = respuesta.productosCertificar;
          }

          else{
            if(respuesta.productosMedir.length == 0 && respuesta.productosMedir2.length == 0 && respuesta.productosPulseCheck.length == 0 && respuesta.productosFocusArea.length == 0){
              prods = respuesta.productosResultados;
              this.sinCertificar = true;
            }
            else prods = [];
          }
          if(localStorage.getItem('tipoIzzi')){
            url = 'certificar'; nombre = 'IZZI';
          }
          else{
            url = 'certificar'; nombre = 'CERTIFICAR';
          }
          break;
          case '2':
            let prodMed1: any = respuesta.productosMedir;
            let prodMed2: any = respuesta.productosMedir2;
            prods = prodMed1.concat(prodMed2); url = 'medir'; nombre = 'MEDIR';
          break;
          case '3': prods = respuesta.productosPulseCheck; url = 'pulse-check'; nombre = 'PULSE'; break;
          case '4': prods = respuesta.productosFocusArea; url = 'focus'; nombre = 'FOCUS'; break;
        }
        prods = this.ordenaDescendente(prods, tipoProducto);
        if(this.conCyR==true){
          prodsRC = this.ordenaDescendenteRYC(prodsRC, tipoProducto);
        }
        // console.log(prods);
        this.colocaProductos(nombre,url,prods,prodsRC,prodsResults);
      });
      break;
    }
    this.ForAllViejas=false;
  }

  ordenaDescendente(datos:any, tipo:string){
    switch(tipo){
      case '1':
      if(!this.sinCertificar){
        datos.sort( (a,b) => { if(a.fechaCertificar < b.fechaCertificar){ return 1; } else{ return -1; } });
      }
      else{
        datos.sort( (a,b) => { if(a.fecha < b.fecha){ return 1; } else{ return -1; } });
      }
      break;
      case '2': datos.sort( (a,b) => { if(a.fechaMedir < b.fechaMedir){ return 1; } else{ return -1; } }); break;
      case '3': datos.sort( (a,b) => { if(a.fechaPulseCheck < b.fechaPulseCheck){ return 1; } else{ return -1; } }); break;
      case '4': datos.sort( (a,b) => { if(a.fechaFocus < b.fechaFocus){ return 1; } else{ return -1; } }); break;
    }
    return datos;
  }

  ordenaDescendenteRYC(prodsRC:any, tipo:string){
    switch(tipo){
      case '1':
      prodsRC.sort( (a,b) => { if(a.fecha < b.fecha){ return 1; } else{ return -1; } });
      break;
    }
    return prodsRC;
  }

  nombreProducto:any="";
  colocaProductos(producto:string, url:string, datos:any, prodsRC:any,prodsResults:any){
    // console.log(datos);
    //agrega un producto de tipo resultados heredados
    this.productosLegacy = [];
    if(producto == 'CERTIFICAR' || producto == 'IZZI'){
      if(this.empresaDeCGO2){
        this.productosLegacy.push(
          {
            category: 'CGO',
            length  : 30,
            title   : 'WIZARD.'+producto+'.TITULO',
            date : 2000,
            url : url,
            productoID : 123,
            start : 'WIZARD.LANDING.ENTRAR',
            completo: 2,
            tagStatus: 'WIZARD.LANDING.PRODUCTO.'+producto+'.RESULTS.FINISHED'
          }
        );
      }
    }
    console.log("Colocar productos");
    if(!this.conCyR){

      datos.forEach( (elem) => {
        console.log(elem);
        let fecha:number;
        let idProducto:string;
        let completo: number;
        let tagStatus: string;
        let tableauVersion: string;
        let activo = true;
        switch(producto){
          case 'CERTIFICAR': case 'IZZI':

          if(!this.sinCertificar){
            fecha = elem.fechaCertificar; idProducto = elem.idCertificar;
            completo = elem.completoCertificar; activo = elem.activo;
          }
          else{

            fecha = elem.fecha; idProducto = elem._id;
            completo = 2; tableauVersion = elem.version; activo = elem.activo;
          }
          break;
          case 'MEDIR':
          this.nombreProducto="";
          if(elem.idMedir){
            fecha = elem.fechaMedir; idProducto = elem.idMedir;
            completo = elem.completoMedir;
          }
          else{
            fecha = elem.fechaProducto; idProducto = elem.idProducto;
            completo = elem.completo;
          }
          break;
          case 'PULSE':
          fecha = elem.fechaPulseCheck; idProducto = elem.idPulseCheck;
          completo = elem.completoPulseCheck;
          break;
          case 'FOCUS':
          fecha = elem.fechaFocus; idProducto = elem.idFocusArea;
          completo = elem.completoFocusArea;
          break;
        }
        switch(completo){
          // case 1: tagStatus = 'WIZARD.LANDING.PRODUCTO.'+producto+'.RESULTS.CURRENT'; break;
          default: tagStatus = 'WIZARD.LANDING.PRODUCTO.'+producto+'.RESULTS.FINISHED';
        }
        this.productosAsignados.push(
          {
            category: 'CGO',
            length  : 30,
            title   : 'WIZARD.'+producto+'.TITULO',
            date : fecha,
            url : url,
            productoID : idProducto,
            start : 'WIZARD.LANDING.ENTRAR',
            completo,
            tagStatus,
            tableauVersion,
            activo
          }
        );
      });

    }
    else{
      prodsRC.forEach( (elem) => {
        console.log(elem);
        let fecha:number;
        let idProducto:string;
        let completo: number;
        let tagStatus: string;
        let tableauVersion: string;
        let activo: boolean;
        let idProductoForall: string;
        switch(producto){
          case 'CERTIFICAR': case 'IZZI':
            fecha = elem.fecha; idProducto = elem._id;
            completo = 2; tableauVersion = elem.version; activo = elem.activo;

            var BreakException = {};
            try {
              datos.forEach((prodCert:any) => {
                if(prodCert.fechaCertificar == elem.fecha){
                  idProductoForall = prodCert.idCertificar;
                  throw BreakException;
                }
              });
            } catch (e) {
                if (e !== BreakException) throw e;
            };
          break;
        }
        switch(completo){
          // case 1: tagStatus = 'WIZARD.LANDING.PRODUCTO.'+producto+'.RESULTS.CURRENT'; break;
          default: tagStatus = 'WIZARD.LANDING.PRODUCTO.'+producto+'.RESULTS.FINISHED5';
        }
        this.productosAsignados.push(
          {
            category: 'CGO',
            length  : 30,
            title   : 'WIZARD.'+producto+'.TITULO',
            date : fecha,
            url : url,
            productoID : idProducto,
            start : 'WIZARD.LANDING.ENTRAR',
            completo,
            tagStatus,
            tableauVersion,
            activo,
            idProductoForall
          }
        );
      });
    }
    this.cargando = false;
    console.log("asignados.",this.productosAsignados);
    this.validarProductos(producto,prodsResults);

  }
  contador=0;
  validarProductos(producto,prodsResults){
    this.contador=0;
    this.productosAsignados_tmp=[];
    switch(producto){
      case 'CERTIFICAR': case 'IZZI':

        this.productosAsignados.forEach( (elem) => {
          if(this.contador < prodsResults.length){
            if(prodsResults[this.contador].tipo == 1 && prodsResults[this.contador].fecha == elem.date){
              console.log("Hay considencia");
              this.productosAsignados_tmp.push(elem);
            }
          }
          this.contador++;

        });
      break;
      case 'MEDIR':
        this.productosAsignados.forEach( (elem) => {
          if(this.contador < prodsResults.length){
            if(prodsResults[this.contador].tipo == 2 && prodsResults[this.contador].fecha == elem.date){
              console.log("Hay considencia");
              this.productosAsignados_tmp.push(elem);
            }
          }
          this.contador++;

        });
      break;
      case 'PULSE':

      break;
      case 'FOCUS':

      break;
    }
    this.productosAsignados=this.productosAsignados_tmp;

  }

  navigateTo(ruta,productoID,tableauVersion,producto?){

    if(producto){
      if(producto.idProductoForall){
        localStorage.setItem('productoID', producto.idProductoForall);
      }
      else{
        localStorage.setItem('productoID', productoID);
      }
    }
    else{
      localStorage.setItem('productoID', productoID);
    }
    this.router.navigate([ruta], { state: {tableauVersion} });
  }

  mensajeSwal(mensaje:string, tipoMsg:number){
    let texto = '';
    this.translateSrv.get(mensaje).subscribe((res: string) => { texto = res; });
    let tipo: any;
    let rspSi = 'MODALES.ACCIONES.aceptar';
    this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
    switch(tipoMsg){
      case 1: tipo = 'success'; break;
      case 2: tipo = 'warning'; break;
      case 3: tipo = 'error'; break;
    }
    Swal.fire({
      title: texto,
      icon: tipo,
      confirmButtonText: rspSi,
      confirmButtonColor: '#e40601'
    });
  }

}
